import { ColorTypes, IconColors } from '@afterpaytouch/core'

interface CheckoutColors {
  textColor: ColorTypes
  headingTextColor: ColorTypes
  cardExpiryDateColor: ColorTypes
  subtextColor: ColorTypes
  iconColor: IconColors
}

interface CheckoutColorParams {
  hasError?: boolean
  isDisabled?: boolean
}

export const useCheckoutColor = (args: CheckoutColorParams = {}): CheckoutColors => {
  const { hasError = false, isDisabled = false } = args

  const disabledContentColor = 'Gray70'
  const disabledHeadingColor = 'Gray60'
  const subTextGrayColor = 'Gray40'
  const defaultTextColor = 'Black'
  const errorColor = 'Fire'

  const textColor = isDisabled ? disabledContentColor : hasError ? errorColor : defaultTextColor
  const headingTextColor = isDisabled ? disabledHeadingColor : hasError ? errorColor : defaultTextColor
  const cardExpiryDateColor = isDisabled ? disabledContentColor : hasError ? errorColor : subTextGrayColor
  const subtextColor = isDisabled ? disabledContentColor : subTextGrayColor
  const iconColor = isDisabled ? 'Gray80' : 'Black'

  return {
    textColor,
    headingTextColor,
    cardExpiryDateColor,
    subtextColor,
    iconColor,
  }
}
